import { Injectable, Inject, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MicrositeInterface, PlatformurlPipe } from '../../../../projects/platform-manager/src/public_api';
import { AppColorService } from './app-color.service';

@Injectable({
  providedIn: 'root'
})
export class MicrositeHelperService {
  private renderer: Renderer2;
  private isInjected = false;

  constructor(
    rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document,
    private platformPipe: PlatformurlPipe,
    private colorService: AppColorService
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  /**
   * adds styles according to set hierarchy in the document head.
   * Will append them at the bottom of the tag.
   * @param micrositeConfig the microsite to add the styles for
   */
  async injectMicrositeStyles(micrositeConfig: MicrositeInterface) {
    if (!this.isInjected) {
      this.isInjected = true;
      const variables = await this.colorService.getColorFor(micrositeConfig.config.style_variables);
      const root = this.document.documentElement;
      this.renderer.setAttribute(
        root,
        'style',
        Object.keys(variables)
          .map(v => {
            return `${v}:${variables[v]}`;
          })
          .join('; ')
      );
      this.renderer.setAttribute(
        this.document.getElementsByName('theme-color')[0],
        'content',
        variables['--primary-color']
      );
      this.colorService.injectPartnerFonts(micrositeConfig.config.variation_name);
    }
  }

  /**
   * adds or updates a canonical link from the partner to alpi in the document head.
   * @param relativeLink the relative link for the canonical link
   */
  injectCanonicalLink(relativeLink: string) {
    let link = this.document.getElementById('canonical');
    let found = true;
    if (!link) {
      link = this.renderer.createElement('link');
      found = false;
    }
    this.renderer.setAttribute(link, 'href', this.platformPipe.transform(relativeLink, true));
    this.renderer.setAttribute(link, 'rel', 'canonical');
    this.renderer.setAttribute(link, 'id', 'canonical');
    if (!found) {
      this.renderer.appendChild(this.document.head, link);
    }
  }

  private;
}
